export default "__VITE_ASSET__3o6RHA5C__"